export default {
  helpPage: {
    title: 'HELP',
    subtitle: 'ゲーム中のヘルプ',
    gameSpecificWarning:
      'こちらのページには一部ネタバレが含まれます。ゲーム体験中でない場合は、閲覧はお控えくださいませ。'
  }
};
